import type { EpisodeFacets, EpisodeListFilters } from "@/api/datasetEpisode";

export const FREEZE_AXIS_LABEL = "최장 영상 정지 후보";
const BOUNDARIES = [0, 10, 15, 20, 30, 60, 120] as const;

/** 서버의 반열림 구간과 동일하다. 마지막 칸은 상한이 없다. */
export function freezeRangeText(min: number, max?: number): string {
  return max === undefined ? `${min}초 이상` : `${min}초 이상 · ${max}초 미만`;
}

export function readFreezeRange(filters: EpisodeListFilters): string {
  return filters.freeze_longest_min === undefined && filters.freeze_longest_max === undefined
    ? ""
    : `${filters.freeze_longest_min ?? 0}:${filters.freeze_longest_max ?? ""}`;
}

/** 범위 선택은 후보 처리 상태를 바꾸지 않는다. */
export function applyFreezeRange(
  filters: EpisodeListFilters,
  value: string | null,
): EpisodeListFilters {
  const next = { ...filters };
  delete next.freeze_longest_min;
  delete next.freeze_longest_max;
  if (!value) return next;
  const [min, max] = value.split(":");
  return {
    ...next,
    freeze_longest_min: Number(min),
    ...(max ? { freeze_longest_max: Number(max) } : {}),
  };
}

export function freezeRangeOptions(
  filters: EpisodeListFilters,
  facets: Pick<EpisodeFacets, "freeze_longest"> | null,
) {
  const axis = facets?.freeze_longest;
  const total = axis && axis.no_candidate + axis.bins.reduce((sum, bin) => sum + bin.count, 0);
  const options: { value: string; label: string; count?: number }[] = [
    { value: "", label: total === undefined ? "전체" : `전체 (${total})` },
    ...BOUNDARIES.map((min, index) => {
      const max = BOUNDARIES[index + 1];
      const bin = axis?.bins.find((bin) => bin.min === min && bin.max === (max ?? null));
      return {
        value: `${min}:${max ?? ""}`,
        label: freezeRangeText(min, max),
        ...(bin ? { count: bin.count } : {}),
      };
    }),
  ];
  const current = readFreezeRange(filters);
  if (current && !options.some((option) => option.value === current)) {
    options.push({
      value: current,
      label: freezeRangeText(filters.freeze_longest_min ?? 0, filters.freeze_longest_max),
    });
  }
  return options;
}

/** 두 조건을 함께 설정하는 명시적인 빠른 필터다. */
export function pendingLongFreeze(filters: EpisodeListFilters): EpisodeListFilters {
  return { ...applyFreezeRange(filters, "30:"), quality_candidate: "pending" };
}
